(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-all-options"] && !Shopify.designMode) return;
  try {
    (()=>{
  if(window.mcSeamlessOptions)return;
  window.mcSeamlessOptions=true;
  let controller;
  document.addEventListener('click',async event=>{
    const choice=event.target.closest('[data-mc-choice]');
    if(!choice||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const picker=choice.closest('.mc-all-options');
    const current=picker?.closest('product-info');
    if(!current||typeof HTMLUpdateUtility==='undefined')return;
    event.preventDefault();
    if(choice.getAttribute('aria-current')==='true'){controller?.abort();picker.removeAttribute('aria-busy');current.productForm?.toggleSubmitButton(false);return;}
    controller?.abort();controller=new AbortController();const signal=controller.signal;
    const url=new URL(choice.href,location.href);
    const focusKey=choice.dataset.mcFocus;
    const top=window.scrollY;
    picker.setAttribute('aria-busy','true');
    current.productForm?.toggleSubmitButton(true);
    try{
      const response=await fetch(url.href,{signal});
      if(!response.ok)throw new Error('Product update failed');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      if(signal.aborted)return;
      const next=html.querySelector('product-info[id^="MainProduct"]');
      if(!next?.querySelector('product-form input[name="id"]'))throw new Error('Missing product form');
      HTMLUpdateUtility.viewTransition(current,next,current.preProcessHtmlCallbacks,[newNode=>{
        window.Shopify?.PaymentButton?.init();
        window.ProductModel?.loadShopifyXR();
        newNode.querySelector(`[data-mc-focus="${focusKey}"]`)?.focus({preventScroll:true});
        newNode.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true}));
      }]);
      const oldImage=document.querySelector('[data-mc-demo] .mc-demo__on');
      const nextImage=html.querySelector('[data-mc-demo] .mc-demo__on');
      if(oldImage&&nextImage){oldImage.src=nextImage.src;oldImage.srcset=nextImage.srcset;oldImage.alt=nextImage.alt;}
      document.title=html.title;
      history.replaceState({...history.state},'',url.pathname+url.search);
      window.scrollTo({top,behavior:'instant'});
    }catch(error){
      if(error.name!=='AbortError'){
        picker.removeAttribute('aria-busy');
        current.productForm?.toggleSubmitButton(false);
        console.error('Midnight selection could not be updated. Select again to retry.',error);
      }
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-gallery-controls"] && !Shopify.designMode) return;
  try {
    (()=>{
  const bind=root=>{
    const products=root.matches?.('product-info')?[root]:root.querySelectorAll('product-info');
    products.forEach(product=>{
      const controls=product.querySelector('[data-mc-gallery-controls]');
      const gallery=product.querySelector('media-gallery');
      const viewer=gallery?.querySelector('[id^=GalleryViewer]');
      if(!controls||!viewer||controls.dataset.bound)return;
      controls.dataset.bound='true';controls.hidden=false;viewer.classList.add('mc-gallery-viewer');viewer.append(controls);
      const button=controls.querySelector('.mc-gallery-light');
      const label=controls.querySelector('[data-mc-gallery-light-label]');
      const slides=[...viewer.querySelectorAll('li[data-media-id]')];
      const progress=controls.querySelector('.mc-gallery-progress');
      let keepOffUntilMedia=null;
      let jumpingToPreview=false;
      let lightLayer=null;
      let lightRequest=0;
      let wantsOff=false;
      const restore=(animate=false)=>{
        keepOffUntilMedia=null;jumpingToPreview=false;wantsOff=false;
        if(animate){
          if(lightLayer)lightLayer.style.opacity='0';
        }else{
          lightRequest++;
          lightLayer?.remove();lightLayer=null;
        }
        button.setAttribute('aria-pressed','true');label.textContent=controls.dataset.onLabel;
      };
      const showOff=(image,url)=>{
        wantsOff=true;
        button.setAttribute('aria-pressed','false');label.textContent=controls.dataset.offLabel;
        if(lightLayer){
          if(lightLayer.dataset.ready==='true')lightLayer.style.opacity='1';
          return;
        }
        const request=++lightRequest;
        const layer=image.cloneNode(false);
        layer.removeAttribute('id');layer.removeAttribute('srcset');layer.removeAttribute('sizes');
        layer.removeAttribute('fetchpriority');layer.loading='eager';layer.alt='';
        layer.setAttribute('aria-hidden','true');layer.classList.add('mc-light-layer');
        layer.style.opacity='0';lightLayer=layer;
        const ready=async()=>{
          try{if(layer.decode)await layer.decode();}catch(error){}
          if(request!==lightRequest||layer!==lightLayer||!layer.naturalWidth)return;
          layer.dataset.ready='true';
          requestAnimationFrame(()=>requestAnimationFrame(()=>{
            if(request===lightRequest&&layer===lightLayer)layer.style.opacity=wantsOff?'1':'0';
          }));
        };
        layer.onload=ready;
        layer.onerror=()=>{if(request===lightRequest)restore();};
        layer.src=url;image.parentElement.append(layer);
        if(layer.complete&&layer.naturalWidth)ready();
      };
      const segment=progress.querySelector('span');segment.style.width=(100/slides.length)+'%';
      progress.addEventListener('click',event=>{const box=progress.getBoundingClientRect();const index=Math.min(slides.length-1,Math.max(0,Math.floor((event.clientX-box.left)/box.width*slides.length)));restore();gallery.setActiveMedia(slides[index].dataset.mediaId,false);paint(slides[index].dataset.mediaId);});
      let currentMediaId=(slides.find(slide=>slide.classList.contains('is-active'))||slides[0])?.dataset.mediaId;
      const position=()=>{
        let active=slides.find(slide=>slide.dataset.mediaId===currentMediaId)||slides[0];
        let media=active?.querySelector('.product-media-container');
        if(!media||media.getBoundingClientRect().width<1){
          active=slides.find(slide=>slide.querySelector('.product-media-container')?.getBoundingClientRect().width>0);
          media=active?.querySelector('.product-media-container');
          if(!media)return;
          if(currentMediaId!==active.dataset.mediaId){
            restore();currentMediaId=active.dataset.mediaId;
            const illustrated=!!active.querySelector('img')?.alt?.toLowerCase().includes('illustrative');
            button.hidden=!illustrated;controls.querySelector('.mc-gallery-edition').hidden=!illustrated;
            segment.style.transform='translateX('+Math.max(0,slides.indexOf(active))*100+'%)';
          }
        }
        const box=media.getBoundingClientRect(),base=viewer.getBoundingClientRect();
        const width=Math.min(box.width,viewer.clientWidth);
        controls.style.inset='auto';controls.style.top=Math.max(0,box.top-base.top)+'px';controls.style.left=Math.max(0,(viewer.clientWidth-width)/2)+'px';controls.style.width=width+'px';controls.style.height=box.height+'px';
      };
      const observer=new ResizeObserver(position);observer.observe(viewer);
      slides.forEach(slide=>{const media=slide.querySelector('.product-media-container');if(media)observer.observe(media);});
      const paint=id=>{currentMediaId=id;position();const active=slides.find(slide=>slide.dataset.mediaId===currentMediaId);const illustrated=!!active?.querySelector('img')?.alt?.toLowerCase().includes('illustrative');button.hidden=!illustrated;controls.querySelector('.mc-gallery-edition').hidden=!illustrated;segment.style.transform='translateX('+Math.max(0,slides.findIndex(slide=>slide.dataset.mediaId===currentMediaId))*100+'%)';};
      paint((slides.find(slide=>slide.classList.contains('is-active'))||slides[0])?.dataset.mediaId);
      viewer.addEventListener('slideChanged',event=>{const id=event.detail.currentElement?.dataset.mediaId;if(!id)return;if(jumpingToPreview&&id!==keepOffUntilMedia)return;jumpingToPreview=false;if(id!==keepOffUntilMedia)restore();paint(id);});
      gallery.querySelector('[id^=GalleryThumbnails]')?.addEventListener('click',event=>{restore();const id=event.target.closest('[data-target]')?.dataset.target;if(id)paint(id);});
      button.addEventListener('click',()=>{
        if(button.getAttribute('aria-pressed')==='false'){restore(true);return;}
        let slide=slides.find(item=>item.dataset.mediaId===currentMediaId)||slides[0];
        if(!slide?.querySelector('img')?.alt?.toLowerCase().includes('illustrative')){
          const preview=slides.find(item=>item.querySelector('img')?.alt?.toLowerCase().includes('illustrative'));
          if(!preview)return;if(preview){restore();slide=preview;keepOffUntilMedia=preview.dataset.mediaId;jumpingToPreview=true;gallery.setActiveMedia(preview.dataset.mediaId,false);paint(preview.dataset.mediaId);}
        }
        const image=slide?.querySelector('.product__media img');
        if(!image||!controls.dataset.offImage)return;
        const source=image.currentSrc||image.src;
        const matchedPairs=[["midnight-v3-panigale-red-city-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-red-city-off.png?v=1793757585"],["midnight-v3-panigale-black-front-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-black-front-off.png?v=1793757636"],["midnight-v3-panigale-red-rear-rider-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-red-rear-rider-off.png?v=1793757658"],["midnight-v3-panigale-black-rear-rider-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-black-rear-rider-off.png?v=1793757613"],["midnight-v3-bat-red-front-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-red-city-off.png?v=1793757585"],["midnight-v3-bat-black-front-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-black-front-off.png?v=1793757636"],["midnight-v3-bat-red-rear-rider-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-red-rear-rider-off.png?v=1793757658"],["midnight-v3-dragon-red-front-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-red-city-off.png?v=1793757585"],["midnight-v3-dragon-black-front-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-black-front-off.png?v=1793757636"],["midnight-v3-dragon-red-rear-rider-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-red-rear-rider-off.png?v=1793757658"],["midnight-v3-dragon-black-rear-rider-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-black-rear-rider-off.png?v=1793757613"],["midnight-color-angel-red-front-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-red-city-off.png?v=1793757585"],["midnight-color-angel-red-rear-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-black-rear-rider-off.png?v=1793757613"],["midnight-color-angel-pink-front-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-red-city-off.png?v=1793757585"],["midnight-color-angel-pink-rear-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-black-rear-rider-off.png?v=1793757613"],["midnight-color-dragon-white-front-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-black-front-off.png?v=1793757636"],["midnight-color-dragon-white-rear-on.png","https://cdn.shopify.com/s/files/1/0788/8610/9338/files/midnight-v3-panigale-black-rear-rider-off.png?v=1793757613"]];
        const matchingOff=matchedPairs.find(pair=>source.includes(pair[0]))?.[1]||controls.dataset.offImage;
        keepOffUntilMedia=slide.dataset.mediaId;
        showOff(image,matchingOff);
      });
    });
  };
  bind(document);
  document.addEventListener('product-info:loaded',event=>bind(event.target));
  document.addEventListener('shopify:section:load',event=>bind(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-shipping"] && !Shopify.designMode) return;
  try {
    (function(){let countryPromise;function countryName(code){try{return new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'}).of(code);}catch{return null;}}function getCountry(){if(countryPromise)return countryPromise;let country,code;try{country=localStorage.getItem('visitor_country');code=localStorage.getItem('visitor_country_code');}catch{}if(country&&/^[A-Z]{2}$/.test(code||''))return Promise.resolve(countryName(code)||country);countryPromise=fetch('https://ipinfo.io/json',{signal:AbortSignal.timeout(6000)}).then(r=>{if(!r.ok)throw Error('Country lookup unavailable');return r.json();}).then(data=>{if(!/^[A-Z]{2}$/.test(data.country||''))return null;const name=countryName(data.country);if(!name)return null;try{localStorage.setItem('visitor_country',name);localStorage.setItem('visitor_country_code',data.country);}catch{}return name;}).catch(()=>null);return countryPromise;}function setShipping(){const elements=document.querySelectorAll('[data-mc-shipping]');if(!elements.length)return;getCountry().then(country=>{if(country)elements.forEach(el=>el.textContent=el.dataset.template.replace('__COUNTRY__',country));});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setShipping);else setShipping();document.addEventListener('shopify:section:load',setShipping);})();
  } catch(e) { console.error(e); }
})();

})();
